import React, { useContext } from 'react';
import { ControlPanelContext } from '../../data/control-panel-context/ControlPanelConf';
import { PvrContext } from '../../data/pvr/PvrConf';
import PrintSettingsBox from './PrintSettingsBox';
import PrintTickets from './PrintTickets';

function ControlPanelItems(props) {
	const controlPanelContext = useContext(ControlPanelContext);
	const pvrContext = useContext(PvrContext);
	const idPvr = pvrContext.pvrSectionEnabled? pvrContext.idPvr : null;
	return (
        <>
            {controlPanelContext.printTicketBoxIsShowable() &&
                <PrintTickets idPvr={idPvr} />
            }
            {controlPanelContext.printSettingsBoxIsShowable() &&
                <PrintSettingsBox />
            }
        </>
    );
}

export default ControlPanelItems;